import { BuiltInDimension } from '@fullstory/proto/fs/api/metrics';

// the LLM will use friendly strings to describe dimensions.
// this map will convert those strings to the built-in dimension enum values.
const dimensionMap: Record<string, BuiltInDimension> = {
  page: BuiltInDimension.DIMENSION_PAGE_DEF_ID,
  city: BuiltInDimension.DIMENSION_CITY,
  state: BuiltInDimension.DIMENSION_STATE,
  country: BuiltInDimension.DIMENSION_COUNTRY,
  email: BuiltInDimension.DIMENSION_EMAIL,
  userid: BuiltInDimension.DIMENSION_USER_ID,
  name: BuiltInDimension.DIMENSION_NAME,
  useragent: BuiltInDimension.DIMENSION_USER_AGENT,
  appname: BuiltInDimension.DIMENSION_APP_NAME,
  devicemodel: BuiltInDimension.DIMENSION_DEVICE_MODEL,
  browser: BuiltInDimension.DIMENSION_BROWSER,
  device: BuiltInDimension.DIMENSION_DEVICE,
  platform: BuiltInDimension.DIMENSION_PLATFORM,
  os: BuiltInDimension.DIMENSION_OS,
  appversion: BuiltInDimension.DIMENSION_APP_VERSION,
  url: BuiltInDimension.DIMENSION_URL,
  urlhost: BuiltInDimension.DIMENSION_URL_HOST,
};

const builtInDimensionToDisplayMap: Record<BuiltInDimension, string> = Object.entries(
  dimensionMap,
).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {} as Record<BuiltInDimension, string>);

export const llmDisplayDimensionToBuiltInDimension = (
  dimension: string,
): BuiltInDimension | undefined => {
  const normalizedDimension = dimension.toLowerCase();
  return dimensionMap[normalizedDimension];
};

export const builtInDimensionToLlmDisplayDimension = (
  dimension: BuiltInDimension,
): string | undefined => builtInDimensionToDisplayMap[dimension];

export const determineLibraryObjectIdType = (id: string) => {
  const isHash = /^\d+$/.test(id);

  return {
    id: isHash ? '' : id,
    hash: isHash ? id : '',
  };
};
